import * as types from '@/store/mutation-types'
import Cookies from 'js-cookie'
import { COOKIE_NAME } from 'enums/cookie'

export default function({ store }) {
  if (process.server) return

  const accessToken = Cookies.get(COOKIE_NAME.ACCESS_TOKEN)

  if (accessToken) {
    store.commit(`auth/${types.SET_ACCESS_TOKEN}`, accessToken)
  }
}
